import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/RobloxLinking.css';
import '../styles/AuthForms.css';

function RobloxLinkingPage() {
  const { user, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLink = () => {
    setLoading(true);
    const token = localStorage.getItem('auth_token');
    window.location.href = `${import.meta.env.VITE_API_URL}/auth/link-roblox?token=${token}`;
  };

  // Show loading while auth is being checked
  if (authLoading) {
    return (
      <div className="verification-container">
        <div className="verification-card">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to home if not logged in
    window.location.href = '/';
    return null;
  }

  if (user.robloxLinked) {
    // Already linked, redirect to home
    window.location.href = '/';
    return null;
  }

  return (
    <div className="verification-container">
      <div className="verification-card">
        <h2 style={{color: '#00FFFF', marginBottom: '1rem'}}>Link Your Roblox Character</h2>

        <div style={{textAlign: 'left', marginBottom: '2rem'}}>
          <p style={{color: '#fff', marginBottom: '1rem'}}>
            To complete your DripBattle registration, you must link your Roblox character.
          </p>

          <div style={{background: 'rgba(0, 255, 255, 0.1)', padding: '1rem', borderRadius: '8px', border: '1px solid rgba(0, 255, 255, 0.3)'}}>
            <h3 style={{color: '#00FFFF', fontSize: '1.1rem', marginBottom: '0.5rem'}}>Why link your Roblox?</h3>
            <ul style={{color: '#fff', paddingLeft: '1.5rem', margin: 0}}>
              <li>Your Roblox username becomes your DripBattle username</li>
              <li>Your avatar is automatically added to the voting gallery</li>
              <li>Proves you own the Roblox account you're representing</li>
              <li>Required to participate in DripBattle</li>
            </ul>
          </div>
        </div>

        <button
          onClick={handleLink}
          disabled={loading}
          className="btn-link-roblox"
          style={{
            width: '100%',
            padding: '1rem 1.5rem',
            background: 'linear-gradient(135deg, #FF4444 0%, #FF0000 100%)',
            border: 'none',
            borderRadius: '8px',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'transform 0.2s, box-shadow 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            opacity: loading ? 0.6 : 1
          }}
        >
          {loading ? 'Redirecting to Roblox...' : '🎮 Link Roblox Character'}
        </button>

        <p style={{color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.9rem', marginTop: '1rem'}}>
          You'll be redirected to Roblox to authorize DripBattle
        </p>
      </div>
    </div>
  );
}

export default RobloxLinkingPage;
